import { analyticsClient } from '../client/AnalyticsClient';
import { AnalyticsCallEvent } from './callAnalytics.types';

export function trackJoinedGuest(): void {
  analyticsClient.track({
    eventType: AnalyticsCallEvent.CallJoinedGuest,
    eventProperties: {
      call_type: 'group',
    },
  });
}
